import { Form, Select } from 'antd'
import { useMemo } from 'react'

export default function PatientCreate({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item
        label="Nome Completo"
        name={[fieldName, 'action', 'data', 'nome_completo']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="CPF"
        name={[fieldName, 'action', 'data', 'cpf']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item label="Data de Nascimento" name={[fieldName, 'action', 'data', 'data_nascimento']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="Sexo" name={[fieldName, 'action', 'data', 'sexo']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="Telefone" name={[fieldName, 'action', 'data', 'telefone']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="Celular" name={[fieldName, 'action', 'data', 'celular']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
      <Form.Item label="E-mail" name={[fieldName, 'action', 'data', 'email']}>
        <Select options={available} placeholder="Selecione um parâmetro" allowClear />
      </Form.Item>
    </>
  )
}
